import { render } from "./WithoutDrPopup.vue?vue&type=template&id=2fa531ca&scoped=true"
import script from "./WithoutDrPopup.vue?vue&type=script&lang=js"
export * from "./WithoutDrPopup.vue?vue&type=script&lang=js"

import "./WithoutDrPopup.vue?vue&type=style&index=0&id=2fa531ca&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa531ca"]])

export default __exports__